var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckStatus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3463",
    "data-name": "Rectangle 3463",
    width: 247.613,
    height: 247.841,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_25"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_25",
    "data-name": "Artboard \\u2013 25",
    clipPath: "url(#clip-Artboard_25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5515",
    "data-name": "Group 5515",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5514",
    "data-name": "Group 5514",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8262",
    "data-name": "Path 8262",
    d: "M247.613,129.314c-.491,4.067-.919,8.143-1.483,12.2a119.97,119.97,0,0,1-27.105,61.3c-19.181,23.047-43.584,37.735-73.127,42.913-36.646,6.423-70.063-1.792-99.315-24.943-25.08-19.849-40.867-45.821-45.146-77.5C-5.553,91.55,13.014,50.318,55.9,20.449,72.685,8.757,91.748,2.74,112.063.66c2.072-.212,4.143-.439,6.215-.66h10.657c1.1.179,2.2.4,3.313.53,4.636.563,9.329.817,13.9,1.7,29.017,5.578,53.186,19.62,72.256,42.185A120.291,120.291,0,0,1,246.1,106.219c.589,4.135,1.013,8.293,1.513,12.44ZM123.7,11.058C61.618,11,10.779,61.588,10.664,123.529c-.117,62.515,50.461,113.331,112.853,113.386,62.174.054,112.962-50.593,113.031-112.718A113.1,113.1,0,0,0,123.7,11.058",
    fill: "#0d4d99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8263",
    "data-name": "Path 8263",
    d: "M149.9,173.362c.081.207.135.278.131.345-.277,4.408-2.482,6.717-6.846,8.159-7.093,2.343-14.061,4.663-21.663,4.035a21.089,21.089,0,0,1-12.893-5.432c-3.356-3.076-4.594-7.024-4.518-11.545.131-7.706,2.83-14.819,4.825-22.1,1.784-6.515,3.538-13.04,5.215-19.583a18.185,18.185,0,0,0,.367-4.076c.14-6.042-2.39-8.711-8.489-8.377-3.332.183-6.624,1.1-10.16,1.73.439-1.8.84-3.731,1.414-5.609a2.339,2.339,0,0,1,1.276-1.293c7.916-2.945,15.744-6.22,24.468-5.92a21.521,21.521,0,0,1,12.207,4c3.594,2.6,5.913,6.235,5.673,10.669a89.128,89.128,0,0,1-2.145,15.706c-2.3,9.7-5.127,19.267-7.729,28.891a8.06,8.06,0,0,0-.215,1.188c-1.07,9.292,2.616,11.535,13.09,10.585a44.82,44.82,0,0,0,5.992-1.375",
    fill: "#0d4d99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8264",
    "data-name": "Path 8264",
    d: "M135.362,90.67c-9.116-.4-15.5-6.906-15.075-15.381.32-6.424,5.876-11.8,13.465-13.022,9.458-1.527,18.142,5.719,17.867,14.907-.229,7.624-7.747,13.866-16.257,13.5",
    fill: "#0d4d99"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckStatus);
export default __webpack_public_path__ + "static/media/check-status.8d5f67b66393875da13dde9cdd198e20.svg";
export { ForwardRef as ReactComponent };